<h1 mat-dialog-title>
    {{ isEditMode ? 'Notschlachtbescheinigung bearbeiten (Admin)' : 'Notschlachtbescheinigung erstellen' }}
</h1>

<div mat-dialog-content>
    <mat-horizontal-stepper [linear]="false">
        <mat-step>
            <ng-template matStepLabel>Vorlage &amp; Tier</ng-template>

            <div class="form-grid" [formGroup]="form">
                <mat-form-field class="full">
                    <mat-label>Schlachter-Vorlage</mat-label>
                    <mat-select formControlName="vorlage">
                        <mat-option *ngFor="let v of vorlagen" [value]="v.key">{{ v.label }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="full vorlage-preview-actions">
                    <button mat-stroked-button type="button" color="primary" (click)="openVorlagePreview()">
                        PDF anzeigen
                    </button>
                </div>

                <mat-radio-group formControlName="tier_modus" class="full tier-modus">
                    <mat-radio-button value="bestand">Tier aus Kundenstamm</mat-radio-button>
                    <mat-radio-button value="manuell">Manuell eintragen</mat-radio-button>
                </mat-radio-group>

                <div class="full" *ngIf="!isManuell">
                    <kiene-autocomplete
                        *ngIf="autocompleteReady"
                        [required]="false"
                        [genericApiUrl]="'gruppe_tier/search.php'"
                        [placeholder]="'Ohrmarke suchen'"
                        [params]="tierParams"
                        [displayFields]="['ohrmarke_notnull', 'gruppe']"
                        [separator]="' – '"
                        [showClear]="true"
                        [focus]="false"
                        (elementSelected)="onTierSelected($event)"
                    ></kiene-autocomplete>
                    <mat-checkbox
                        [checked]="historieDurchsuchen"
                        (change)="toggleHistorie($event.checked)"
                        class="historie-check"
                    >
                        Auch Historie / bereits verstorbene Tiere
                    </mat-checkbox>
                    <div class="selected-tier" *ngIf="form.get('kennzeichnung').value">
                        Gewählt: {{ form.get('kennzeichnung').value }}
                    </div>
                </div>

                <mat-form-field class="full" *ngIf="isManuell">
                    <mat-label>Kennzeichnung / Ohrmarke</mat-label>
                    <input matInput formControlName="kennzeichnung" />
                </mat-form-field>

                <mat-form-field class="full">
                    <mat-label>Tierart</mat-label>
                    <mat-select
                        formControlName="tierart_id"
                        (selectionChange)="onTierartSelect($event.value)"
                        [required]="isManuell"
                    >
                        <mat-option [value]="null">Keine</mat-option>
                        <mat-option *ngFor="let t of tierarten" [value]="t.tierart_id">{{ t.tierart }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="step-actions">
                <button mat-button matStepperNext>Weiter</button>
            </div>
        </mat-step>

        <mat-step>
            <ng-template matStepLabel>Angaben</ng-template>
            <div class="form-grid" [formGroup]="form">
                <mat-form-field *ngIf="!hideKreisExtraFields">
                    <mat-label>Amtl. Nr. (falls vorhanden)</mat-label>
                    <input matInput formControlName="amtl_nr" />
                </mat-form-field>

                <mat-form-field class="full" *ngIf="!hideKreisExtraFields || isNeutral">
                    <mat-label>{{ isNeutral ? 'Schlachtbetrieb / Schlachthof' : 'Schlachtbetrieb (Bestimmungsort)' }}</mat-label>
                    <input matInput formControlName="schlachtbetrieb" />
                </mat-form-field>
                <mat-form-field *ngIf="isNeutral">
                    <mat-label>Ort Schlachthof („in … gebracht“)</mat-label>
                    <input matInput formControlName="sb_ort" />
                </mat-form-field>

                <ng-container *ngIf="isSteinfurt || isSchwarting || isNeutral">
                    <h4 class="full">
                        {{
                            isNeutral
                                ? 'Erzeugerbetrieb (Untersuchung, Seite 2)'
                                : isSchwarting
                                  ? 'Herkunftsbetrieb (Untersuchung)'
                                  : 'Ort der Notschlachtung'
                        }}
                    </h4>
                    <mat-form-field>
                        <mat-label>Straße</mat-label>
                        <input matInput formControlName="ns_strasse" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Hausnummer</mat-label>
                        <input matInput formControlName="ns_hausnummer" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>PLZ</mat-label>
                        <input matInput formControlName="ns_plz" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Ort</mat-label>
                        <input matInput formControlName="ns_ort" />
                    </mat-form-field>

                    <ng-container *ngIf="isSteinfurt">
                        <h4 class="full">Bestimmungsort (Adresse)</h4>
                        <mat-form-field>
                            <mat-label>Straße Schlachtbetrieb</mat-label>
                            <input matInput formControlName="sb_strasse" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Hausnummer</mat-label>
                            <input matInput formControlName="sb_hausnummer" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>PLZ</mat-label>
                            <input matInput formControlName="sb_plz" />
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Ort</mat-label>
                            <input matInput formControlName="sb_ort" />
                        </mat-form-field>
                    </ng-container>
                </ng-container>

                <mat-form-field class="full" *ngIf="!hideKreisExtraFields">
                    <mat-label>Transportmittel</mat-label>
                    <input matInput formControlName="transportmittel" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Datum Untersuchung</mat-label>
                    <input matInput [matDatepicker]="du" formControlName="datum_untersuchung" />
                    <mat-datepicker-toggle matSuffix [for]="du"></mat-datepicker-toggle>
                    <mat-datepicker #du></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Uhrzeit Untersuchung</mat-label>
                    <input matInput formControlName="uhrzeit_untersuchung" placeholder="HH:mm" />
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Datum Schlachtung</mat-label>
                    <input matInput [matDatepicker]="ds" formControlName="datum_schlachtung" />
                    <mat-datepicker-toggle matSuffix [for]="ds"></mat-datepicker-toggle>
                    <mat-datepicker #ds></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Uhrzeit Schlachtung</mat-label>
                    <input matInput formControlName="uhrzeit_schlachtung" placeholder="HH:mm" />
                </mat-form-field>

                <mat-form-field class="full">
                    <mat-label>Grund der Notschlachtung (Diagnose)</mat-label>
                    <textarea matInput rows="2" formControlName="grund"></textarea>
                </mat-form-field>

                <!-- Kreis-/Allgemein-Felder: bei Friesoythe/Schwarting nicht auf dem PDF -->
                <ng-container *ngIf="!hideKreisExtraFields">
                    <mat-form-field class="full">
                        <mat-label>Tiergesundheit / Tierschutz / Befunde</mat-label>
                        <textarea matInput rows="2" formControlName="gesundheit"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full">
                        <mat-label>Behandlungen</mat-label>
                        <textarea matInput rows="2" formControlName="behandlung"></textarea>
                    </mat-form-field>

                    <mat-form-field class="full">
                        <mat-label>Sonstige Angaben</mat-label>
                        <textarea matInput rows="2" formControlName="sonstige"></textarea>
                    </mat-form-field>
                </ng-container>

                <mat-form-field class="full" *ngIf="isFischer">
                    <mat-label>Optional (*)</mat-label>
                    <textarea matInput rows="2" formControlName="optional"></textarea>
                </mat-form-field>

                <mat-form-field>
                    <mat-label>Ausgestellt in (Ort)</mat-label>
                    <input matInput formControlName="ort" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Datum Ausstellung</mat-label>
                    <input matInput [matDatepicker]="da" formControlName="datum" />
                    <mat-datepicker-toggle matSuffix [for]="da"></mat-datepicker-toggle>
                    <mat-datepicker #da></mat-datepicker>
                </mat-form-field>

                <ng-container *ngIf="isDiekmann">
                    <h4 class="full">
                        {{
                            isNeutral
                                ? 'Neutral – Angaben zum Tier & Untersuchung'
                                : isHohn
                                  ? 'Hohn – Angaben zum Tier & Untersuchung'
                                  : isRolfes
                                    ? 'Rolfes – Angaben zum Tier & Untersuchung'
                                    : isSchwarting
                                      ? 'Schwarting – Angaben zum Tier & Untersuchung'
                                      : isDiekmannFriesoythe
                                        ? 'Friesoythe – Angaben zum Tier & Untersuchung'
                                        : 'Zusatzfelder (Begleitschein)'
                        }}
                    </h4>
                    <mat-form-field>
                        <mat-label>Rasse</mat-label>
                        <input matInput formControlName="rasse" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Geschlecht (m/w)</mat-label>
                        <input matInput formControlName="geschlecht" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Alter</mat-label>
                        <input matInput formControlName="alter" />
                    </mat-form-field>
                    <div class="full check-row" *ngIf="!hideKennCheckboxes">
                        <mat-checkbox formControlName="kenn_ohrmarken">Ohrmarken</mat-checkbox>
                        <mat-checkbox *ngIf="!isDiekmannFriesoythe" formControlName="kenn_chip">Chip</mat-checkbox>
                        <mat-checkbox *ngIf="!isDiekmannFriesoythe" formControlName="kenn_equidenpass"
                            >Equidenpass</mat-checkbox
                        >
                        <mat-checkbox formControlName="kenn_taetowierung">Tätowierung</mat-checkbox>
                    </div>
                    <!-- Herbergen: Ohrmarke kommt aus Schritt 1 (Tierauswahl); PDF nutzt kennzeichnung als Fallback -->
                    <mat-form-field *ngIf="!isDiekmannHerbergen">
                        <mat-label>{{
                            isSchwarting || isDiekmannFriesoythe || isHohn || isNeutral
                                ? 'Ohrmarken-/Chip-/Equidenpass-/Tätowierung-Nr.'
                                : 'Nr. (Kennzeichnung / Tätowierung)'
                        }}</mat-label>
                        <input matInput formControlName="taetowierung_nr" />
                    </mat-form-field>

                    <h4 class="full" *ngIf="isDiekmannFriesoythe || isSchwarting || isRolfes || isHohn || isNeutral">
                        Ergebnis Schlachttieruntersuchung
                    </h4>
                    <mat-form-field>
                        <mat-label>Körpertemperatur °C</mat-label>
                        <input matInput formControlName="temperatur" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Herzschlagfrequenz</mat-label>
                        <input matInput formControlName="herzfrequenz" />
                    </mat-form-field>
                    <mat-form-field>
                        <mat-label>Atemfrequenz</mat-label>
                        <input matInput formControlName="atemfrequenz" />
                    </mat-form-field>
                    <mat-form-field class="full">
                        <mat-label>Sonstige Befunde</mat-label>
                        <textarea matInput rows="2" formControlName="sonstige_befunde"></textarea>
                    </mat-form-field>

                    <ng-container *ngIf="isSchwarting || isHohn || isNeutral">
                        <h4 class="full">Behandlung durch Tierarzt</h4>
                        <div class="full check-row">
                            <span class="check-row-label">Behandlung durchgeführt:</span>
                            <mat-checkbox formControlName="behandlung_ja" (change)="onBehandlungJa($event.checked)"
                                >Ja</mat-checkbox
                            >
                            <mat-checkbox formControlName="behandlung_nein" (change)="onBehandlungNein($event.checked)"
                                >Nein</mat-checkbox
                            >
                        </div>
                        <mat-form-field class="full" *ngIf="form.get('behandlung_ja').value">
                            <mat-label>Durchgeführte Behandlung</mat-label>
                            <textarea matInput rows="2" formControlName="behandlung"></textarea>
                        </mat-form-field>
                    </ng-container>

                    <div class="full check-row" *ngIf="isDiekmannHerbergen">
                        <mat-checkbox formControlName="kfz_clp_dh_43">Kfz CLP-DH 43</mat-checkbox>
                        <mat-checkbox formControlName="kfz_clp_dh_36">Kfz CLP-DH 36</mat-checkbox>
                    </div>
                    <mat-form-field *ngIf="!isSchwarting && !isHohn && !isNeutral">
                        <mat-label>{{
                            isRolfes
                                ? 'Kfz-Nummer (sonstige; LER-AN 326 ist vorgedruckt)'
                                : isDiekmannHerbergen
                                  ? 'Kfz-Nummer (sonstige)'
                                  : 'Kfz-Nummer (mobile Einheit)'
                        }}</mat-label>
                        <input matInput formControlName="kfz_nummer" />
                    </mat-form-field>

                    <ng-container *ngIf="showBegleitArzneimittelFleisch">
                        <h4 class="full">
                            {{
                                isNeutral
                                    ? 'Arzneimittel (Lebensmittelunternehmer, Seite 1)'
                                    : isHohn || isSchwarting
                                      ? 'Arzneimittel (Lebensmittelunternehmer)'
                                      : 'Arzneimittel (Seite 2)'
                            }}
                        </h4>
                        <div class="full check-row">
                            <span class="check-row-label">Mit Arzneimitteln behandelt:</span>
                            <mat-checkbox formControlName="arzneimittel_ja" (change)="onArzneimittelJa($event.checked)"
                                >Ja</mat-checkbox
                            >
                            <mat-checkbox formControlName="arzneimittel_nein" (change)="onArzneimittelNein($event.checked)"
                                >Nein</mat-checkbox
                            >
                        </div>
                        <mat-form-field class="full" *ngIf="form.get('arzneimittel_ja').value">
                            <mat-label>{{
                                isHohn ? 'Angabe des/der Arzneimittel' : 'Angabe Arzneimittel, Behandlungsdatum, Wartezeit'
                            }}</mat-label>
                            <textarea matInput rows="2" formControlName="arzneimittel_angabe"></textarea>
                        </mat-form-field>
                        <mat-form-field *ngIf="isHohn && form.get('arzneimittel_ja').value">
                            <mat-label>Wartezeit</mat-label>
                            <input matInput formControlName="wartezeit" />
                        </mat-form-field>
                        <mat-form-field *ngIf="isHohn && form.get('arzneimittel_ja').value">
                            <mat-label>Behandlungsdaten</mat-label>
                            <input matInput formControlName="behandlungsdaten" />
                        </mat-form-field>

                        <!-- Herbergen: Abschnitt 4 bleibt leer (andere Person unterschreibt später) -->
                        <ng-container *ngIf="!isDiekmannHerbergen">
                            <h4 class="full">
                                {{
                                    isSchwarting
                                        ? 'Fleischuntersuchung'
                                        : isHohn
                                          ? 'Fleischuntersuchung (Seite 2 / Zusatzdokument)'
                                          : isNeutral
                                            ? 'Fleischuntersuchung (Seite 2, optional)'
                                            : 'Fleischuntersuchung (Seite 2)'
                                }}
                            </h4>
                            <div class="full check-row">
                                <span class="check-row-label">{{
                                    isHohn || isNeutral ? 'Genusstauglich (Seite 2):' : 'Genusstauglich / bestätigt:'
                                }}</span>
                                <mat-checkbox formControlName="fleisch_ja" (change)="onFleischJa($event.checked)"
                                    >Ja</mat-checkbox
                                >
                                <mat-checkbox formControlName="fleisch_nein" (change)="onFleischNein($event.checked)"
                                    >Nein</mat-checkbox
                                >
                            </div>
                            <div class="full check-row" *ngIf="isHohn">
                                <span class="check-row-label">Wenn Fleischuntersuchung nein:</span>
                                <mat-checkbox formControlName="fleisch_nein_plausibel"
                                    >Erklärung Nr. 3 nicht plausibel / Abbruch</mat-checkbox
                                >
                                <mat-checkbox formControlName="fleisch_nein_untauglich"
                                    >Beurteilung genussuntauglich</mat-checkbox
                                >
                            </div>
                            <mat-form-field class="full" *ngIf="form.get('fleisch_nein').value">
                                <mat-label>Befunde Fleischuntersuchung (wenn nein)</mat-label>
                                <textarea matInput rows="2" formControlName="fleisch_befunde"></textarea>
                            </mat-form-field>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <div class="step-actions">
                <button mat-button matStepperPrevious>Zurück</button>
                <button mat-button matStepperNext>Weiter</button>
            </div>
        </mat-step>

        <mat-step *ngIf="!tierarztGesetzt">
            <ng-template matStepLabel>Tierarzt</ng-template>
            <kiene-autocomplete
                [focus]="false"
                [genericApiUrl]="'tierarzt/read_autocomplete.php'"
                [placeholder]="'Tierarzt'"
                [displayFields]="['vorname', 'nachname']"
                (elementSelected)="setSelectedTierarzt($event)"
            ></kiene-autocomplete>
            <div class="step-actions">
                <button mat-button matStepperPrevious>Zurück</button>
                <button mat-button matStepperNext>Weiter</button>
            </div>
        </mat-step>

        <mat-step *ngIf="!isEditMode">
            <ng-template matStepLabel>Unterschreiben</ng-template>
            <kiene-qr-code-sign-field [signature]="signature"></kiene-qr-code-sign-field>
            <div class="step-actions">
                <button mat-button matStepperPrevious>Zurück</button>
                <button mat-button (click)="cancel()">Abbrechen</button>
                <button mat-flat-button color="accent" (click)="createPdf()" [disabled]="isSaving">
                    Bescheinigung erstellen
                </button>
            </div>
        </mat-step>

        <mat-step *ngIf="isEditMode">
            <ng-template matStepLabel>PDF speichern</ng-template>
            <p class="admin-hint">
                Admin-Modus: gespeicherte Formulardaten werden aktualisiert und das PDF neu erzeugt (ohne neue
                Unterschrift).
            </p>
            <div class="step-actions">
                <button mat-button matStepperPrevious>Zurück</button>
                <button mat-button (click)="cancel()">Abbrechen</button>
                <button mat-flat-button color="accent" (click)="createPdf()" [disabled]="isSaving">
                    PDF neu speichern
                </button>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</div>
